import {makeActionCreator} from '../utility'

export const FETCH_AWARD_TYPES = 'FETCH_AWARD_TYPES'
export const fetchAwardTypes = makeActionCreator(FETCH_AWARD_TYPES, 'data')

export const FETCH_AWARD_TYPES_SUCCESSFUL = 'FETCH_AWARD_TYPES_SUCCESSFUL'
export const fetchAwardTypesSuccessful = makeActionCreator(FETCH_AWARD_TYPES_SUCCESSFUL, 'data')